import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {map} from 'rxjs/operators';
import {StaffTypeLabel} from 'src/app/models/shift-management-models/StaffTypeLabel';

export enum RN {
  Supervisor = 'RNSUPERVISOR',
  Default = 'RN'
}

const _staffTypeMapper: (staffType: StaffTypeLabel) => string = staffType => staffType.shiftTypeKey;

@Injectable({
  providedIn: 'root'
})
export class RnSupervisorService {
  staffTypesSubject: BehaviorSubject<StaffTypeLabel[]> = new BehaviorSubject([]);
  rnChecked = new Subject<boolean>();
  supervisorChecked = new Subject<boolean>();
  private readonly _unsubscribe: Subject<any> = new Subject<any>();


  /**
   * Checks if the notice should enabled for the current facility/client.
   * @returns {boolean}
   */
  shouldEnable() {
    return this.staffTypesSubject.pipe(map(this.clientHasBoth));

  }

  clientHasBoth(staffTypes: StaffTypeLabel[]) {
    return [RN.Default, RN.Supervisor].every(st => staffTypes.map(_staffTypeMapper).includes(st));
  }
}
